import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { MonthYearHelpers } from '@common/types';
import { Gantt, GanttColumn, GanttView } from '@progress/kendo-gantt-vue-wrapper';
import { ICommandBase } from '@Quest/cqrs';
import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue';
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { SchedulingPageReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioNavigation, PortfolioScenarioNavigation,
        'gantt': Gantt, 'gantt-view': GanttView, 'gantt-column': GanttColumn,
    }
})
export default class SchedulingPage extends mixins(PortfolioScenariosQueries, PortfolioScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get scenarioId() { return this.$route.params.scenarioId; }

    rm: SchedulingPageReadModel | null = null;

    get ds()
    {
        if (!this.rm) return null;

        const view = this.rm.Projects.filter(a => a.EndDate).map(a => 
        {
            const start = MonthYearHelpers.toDate(MonthYearHelpers.buildFromMonthYearString(a.StartDate));
            const end = MonthYearHelpers.toDate(MonthYearHelpers.buildFromMonthYearString(a.EndDate));

            return {
                id: a.Id,
                title: a.Name,
                start: start,
                end: end,
            };
        });

        return view;
    }

    get dataSource()
    {
        return new kendo.data.GanttDataSource({
            data: this.ds
        });
    }

    edit(e: any)
    {
        const selection = e.sender.select();
        const task = e.sender.dataItem(selection);
        const alternative = this.rm!.Projects.find(a => a.Id === task.id);

        //emit
        //this.schedulingForm.show(alternative);

        //const selection = e.sender.select();
        //const task = e.sender.dataItem(selection);

        //if (this.selectedId === task.id)
        //{
        //    const alternative = this.alternatives.find(a => a.rm.AlternativeId === this.selectedId);
        //    this.schedulingForm.show(alternative);
        //}
        //else
        //{
        //    this.selectedId = task.id;
        //}
    }

    mounted()
    {
        document.title = "Portfolio Plan - Schedule";
        this.runSchedulingPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "SchedulingPageReadModel")
        {
            this.rm = model as SchedulingPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        //if (AddPortfolioScenarioItemsFromListCommandV1.matchType(cmd))
        //{
        //    this.refresh();
        //}
    }
}